module.exports = __webpack_public_path__ + "static/media/LogicWheel1_4_2.b23e0a5d.png";